import classNames from 'classnames'
import React from 'react'
import SVGIcon from '../svg/SVGIcon'
import useToggle from '../utils/useToggle'
import s from './Details.less'
import down from './assets/down.svg'

export default function Details({ summary, classes = [], toggleClasses = [], children }) {
  const [open, onClick] = useToggle()

  return (
    <details open={open} className={classNames(s.Details, ...classes)}>
      <summary className={s.Summary} onClick={onClick}>
        {summary}
        <span className={classNames(s.Chevron, ...toggleClasses)}>
          <SVGIcon url={down} />
        </span>
      </summary>
      <div className={s.Content}>{children}</div>
    </details>
  )
}
